import { staticInfo } from './../staticInfo';
import { DateService } from '../services/date.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class YearInterceptor implements HttpInterceptor {
  constructor(private dateService: DateService) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.checkUrl(request.url)) {

      const selectedYear = this.dateService.selectedYearSource.getValue();
      // let year = selectedYear == '2020' ? '2021' : selectedYear == '2021' ? '2020' : selectedYear;
      // let year = (+selectedYear - 1).toString();
      request = request.clone({
        setParams: {
          year: selectedYear,
        },
      });
    }
    return next.handle(request);
  }

  checkUrl(url) {
    const indexOfFirstParam = url.indexOf('?');
    const indexOfendOfBaseUrl = url.indexOf('api/');

    let endPoint =
      indexOfFirstParam != -1
        ? url.substring(indexOfendOfBaseUrl + 3, indexOfFirstParam)
        : url.substring(indexOfendOfBaseUrl + 3);

    let isFound =
      staticInfo.apis_accept_year_qparam_for_year_interceptor.includes(
        endPoint
      );

    return isFound;
  }
}
